import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const RequestsCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('requests'), link: '/requests-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createRequest = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let adminAnswer = event.target.requestAdminAnswer.value.trim();
		let adminFile = document.querySelector('#requestAdminFile-upload-list a')?.getAttribute('href').trim();
		let status = event.target.requestStatus.value;
		let body = {
			request_id: id,
			admin_answer_request_information: {
				admin_answer: adminAnswer,
				admin_attachment: adminFile
			},
			request_state: status
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/requests/admin/' + componentType, body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	}
	const [request, setRequest] = useState({});
	const getRequest = async () => {
		let body = {
			request_id: id
		};
		let response = await _post('/requests/admin/getOne', body);
		switch(response.code){
			case 200:
				setRequest(response.data.request);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const requestStatusList = [
		{ key: t('pending'), value: 0 },
		{ key: t('canceled'), value: 3 },
		{ key: t('confirmed'), value: 1 },
		{ key: t('failed'), value: 2 }
	];

	useEffect(() => {
		if(componentType === 'edit')
			getRequest();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('request')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createRequest}>
						<div className="row gx-2">
							<FormField type="text" fieldKey="requestDescription" title={t('description')} value={request?.request_information?.description} disabled rtl />
							<FormField type="file" fieldKey="requestFile" title={t('file')} value={request?.request_information?.file} disabled fileMaxSize={2} />
							<FormField type="text" fieldKey="requestAdminAnswer" title={t('admin_answer')} value={request?.admin_answer_request_information?.admin_answer} rtl />
							<FormField type="file" fieldKey="requestAdminFile" title={t('admin_file')} value={request?.admin_answer_request_information?.admin_attachment} fileMaxSize={2} />
							<FormField fieldKey="requestUser" title={t('user')} value={request?.user_id_information ? request?.user_id_information?.user_fullname + ' - ' + request?.user_id_information?.phone_number : ''} disabled rtl />
							<FormField fieldKey="requestCategory" title={t('category')} value={request?.requestcategory_id_information?.requestcategory_name} disabled rtl />
							<FormField type="select" fieldKey="requestStatus" title={t('status')} value={request?.request_state} required selectItems={requestStatusList} />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('update')}
								</LoadingButton>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default RequestsCreate;
